import { cloneDeep } from "lodash-es";
import { ResultRow } from "../../../data-structures/results/result-row.model";

interface LeverageRatiosInterface {
 'RESULTS.DATA.ECONOMIC_METRICS.D2ER'?: ResultRow;
 'RESULTS.DATA.ECONOMIC_METRICS.D2CR'?: ResultRow;
 'RESULTS.DATA.ECONOMIC_METRICS.D2EBITDAR'?: ResultRow;
}
export class LeverageRatios {
  'RESULTS.DATA.ECONOMIC_METRICS.D2ER';
  'RESULTS.DATA.ECONOMIC_METRICS.D2CR';
  'RESULTS.DATA.ECONOMIC_METRICS.D2EBITDAR';
  /** debt-to-equity ratio */
  get d2er() {
    return this['RESULTS.DATA.ECONOMIC_METRICS.D2ER'];
  }
  set d2er(value: ResultRow) {
    this['RESULTS.DATA.ECONOMIC_METRICS.D2ER'] = value;
  }
  /** debt-to-capital ratio */
  get d2cr() {
    return this['RESULTS.DATA.ECONOMIC_METRICS.D2CR'];
  }
  set d2cr(value: ResultRow) {
    this['RESULTS.DATA.ECONOMIC_METRICS.D2CR'] = value;
  }
  /** debt-to-EBITDA ratio */
  get d2ebitdar() {
    return this['RESULTS.DATA.ECONOMIC_METRICS.D2EBITDAR'];
  }
  set d2ebitdar(value: ResultRow) {
    this['RESULTS.DATA.ECONOMIC_METRICS.D2EBITDAR'] = value;
  }

  constructor(param: LeverageRatiosInterface = {}) {
    this['RESULTS.DATA.ECONOMIC_METRICS.D2ER'] = param['RESULTS.DATA.ECONOMIC_METRICS.D2ER']
      ? new ResultRow(param['RESULTS.DATA.ECONOMIC_METRICS.D2ER'])
      : new ResultRow();

    this['RESULTS.DATA.ECONOMIC_METRICS.D2CR'] = param['RESULTS.DATA.ECONOMIC_METRICS.D2CR']
      ? new ResultRow(param['RESULTS.DATA.ECONOMIC_METRICS.D2CR'])
      : new ResultRow();

    this['RESULTS.DATA.ECONOMIC_METRICS.D2EBITDAR'] = param['RESULTS.DATA.ECONOMIC_METRICS.D2EBITDAR']
      ? new ResultRow(param['RESULTS.DATA.ECONOMIC_METRICS.D2EBITDAR'])
      : new ResultRow();
  }

  deepCopy() {
    return new LeverageRatios(cloneDeep(this));
  }
}